/**
 * Andrade PDP — galeria + barra flutuante (ES5).
 * Variante ativa = combinação dos radios (cor + tamanho), não o JSON atrasado do picker.
 */
(function () {
  'use strict';

  var state = {
    lastVariantId: null,
    lastGalleryKey: null,
    changeGeneration: 0,
  };

  function norm(value) {
    if (value == null) return null;
    return String(value).trim();
  }

  function parseJson(el) {
    if (!el || !el.textContent) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function getPdpRoot() {
    return document.querySelector('[data-md-pdp]');
  }

  function getPicker() {
    var root = getPdpRoot();
    return root ? root.querySelector('variant-picker.andrade-pdp-variant-picker') : null;
  }

  function parseMap(root) {
    return parseJson(root.querySelector('[data-md-gallery-variant-map]'));
  }

  function parseAllVariants(root) {
    var map = parseMap(root || getPdpRoot());
    if (map && map.allVariants && map.allVariants.length) return map.allVariants;

    var scope = root || getPdpRoot();
    var el = scope ? scope.querySelector('[data-md-all-variants]') : null;
    if (!el) el = document.querySelector('[data-md-all-variants]');
    return parseJson(el) || [];
  }

  function getPickerVariantFromScript() {
    var picker = getPicker();
    if (!picker) return null;
    return parseJson(picker.querySelector('script[type="application/json"]'));
  }

  function matchVariantFromSelections(allVariants, picker) {
    if (!allVariants || !allVariants.length || !picker) return null;

    var selections = {};
    var fieldsets = picker.querySelectorAll('fieldset');

    for (var i = 0; i < fieldsets.length; i += 1) {
      var checked = fieldsets[i].querySelector('input[type="radio"]:checked');
      if (!checked) continue;

      var pos = Number(checked.dataset.inputId ? checked.dataset.inputId.split('-')[0] : 0);
      if (!pos) continue;
      selections[String(pos)] = norm(checked.value);
    }

    var keys = Object.keys(selections);
    if (!keys.length) return null;

    var match = null;
    var matchCount = 0;

    for (var j = 0; j < allVariants.length; j += 1) {
      var v = allVariants[j];
      var ok = true;

      for (var k = 0; k < keys.length; k += 1) {
        var p = Number(keys[k]);
        var sel = selections[keys[k]];

        if (p === 1 && norm(v.option1) !== sel) ok = false;
        else if (p === 2 && norm(v.option2) !== sel) ok = false;
        else if (p === 3 && norm(v.option3) !== sel) ok = false;
      }

      if (ok) {
        match = v;
        matchCount += 1;
        if (matchCount > 1 && keys.length === fieldsets.length) {
          /* várias variantes com mesma combinação parcial — continua */
        }
      }
    }

    return match;
  }

  function mergeVariant(base, extra) {
    if (!base) return extra;
    if (!extra) return base;
    if (String(base.id) !== String(extra.id)) return base;
    var merged = {};
    var key;
    for (key in base) {
      if (Object.prototype.hasOwnProperty.call(base, key)) merged[key] = base[key];
    }
    for (key in extra) {
      if (Object.prototype.hasOwnProperty.call(extra, key)) merged[key] = extra[key];
    }
    return merged;
  }

  function resolveActiveVariant(root) {
    var picker = getPicker();
    var allVariants = parseAllVariants(root);
    var fromSelection = matchVariantFromSelections(allVariants, picker);
    var fromScript = getPickerVariantFromScript();

    /* Sempre prioriza cor+tamanho dos radios — o JSON do picker traz só a opção clicada */
    if (fromSelection && fromSelection.id) {
      if (fromScript && String(fromScript.id) === String(fromSelection.id)) {
        return mergeVariant(fromSelection, fromScript);
      }
      return fromSelection;
    }

    if (fromScript && fromScript.id) return fromScript;
    return null;
  }

  function applyResolvedVariant(root, map) {
    var variant = resolveActiveVariant(root);
    if (variant && variant.id) {
      onVariantResolved(root, map, variant);
      return true;
    }
    return false;
  }

  function syncVariantInput(variantId) {
    if (!variantId) return;
    var input =
      document.querySelector('product-form-component input[name="id"]') ||
      document.querySelector('[data-md-product-form] input[name="id"]') ||
      document.querySelector('.section-andrade-product input[name="id"]');
    if (input) input.value = String(variantId);
  }

  function firstImageSrc(map, imageIds) {
    if (!map || !map.images || !imageIds || !imageIds.length) return null;
    var data = map.images[String(imageIds[0])];
    return data && data.src900 ? data.src900 : null;
  }

  function featuredImageId(variant) {
    if (!variant) return null;
    if (variant.featured_media && variant.featured_media.id != null) return String(variant.featured_media.id);
    if (variant.featured_image && variant.featured_image.id != null) return String(variant.featured_image.id);
    return null;
  }

  function resolveVisualGroupValue(root, map) {
    if (!map) return null;
    var picker = getPicker();
    if (picker) {
      var visualFieldset = picker.querySelector('[data-md-visual-option="true"]');
      if (visualFieldset) {
        var visualChecked = visualFieldset.querySelector('input[type="radio"]:checked');
        if (visualChecked) return norm(visualChecked.value);
      }
    }

    var visualKey = map.visualOption || 'option1';
    var pos = visualKey === 'option2' ? 2 : visualKey === 'option3' ? 3 : 1;
    if (!picker) return null;

    var fieldsets = picker.querySelectorAll('fieldset');
    for (var i = 0; i < fieldsets.length; i += 1) {
      var checked = fieldsets[i].querySelector('input[type="radio"]:checked');
      if (!checked) continue;
      var inputPos = Number(checked.dataset.inputId ? checked.dataset.inputId.split('-')[0] : 0);
      if (inputPos === pos) return norm(checked.value);
    }

    if (map.resolver && map.resolver.groupsOrdered && map.resolver.groupsOrdered.length === 1) {
      return norm(map.resolver.groupsOrdered[0]);
    }
    return null;
  }

  function computeGalleryIds(map, groupValue, variant) {
    if (!groupValue && variant && window.AndradePdpGallery) {
      groupValue = window.AndradePdpGallery.groupForVariant(variant, map.visualOption || 'option1');
    }
    if (!groupValue && map.resolver && map.resolver.groupsOrdered && map.resolver.groupsOrdered.length === 1) {
      groupValue = map.resolver.groupsOrdered[0];
    }
    if (window.AndradePdpGallery && map.resolver && groupValue) {
      var computed = window.AndradePdpGallery.computeForGroup(map, groupValue);
      if (computed && computed.length) return computed;
    }
    return null;
  }

  function reorderGalleryIds(map, ids, groupValue, variant) {
    if (
      !ids ||
      !ids.length ||
      !groupValue ||
      !window.AndradePdpGallery ||
      !window.AndradePdpGallery.orderGroupImageIds ||
      !map.resolver ||
      !map.resolver.images
    ) {
      return ids;
    }

    var include = {};
    var i;
    for (i = 0; i < ids.length; i += 1) include[String(ids[i])] = true;

    var feat = null;
    if (variant) {
      if (variant.featured_media && variant.featured_media.id != null) feat = variant.featured_media.id;
      else if (variant.featured_image && variant.featured_image.id != null) feat = variant.featured_image.id;
    }

    return (
      window.AndradePdpGallery.orderGroupImageIds(
        map.resolver.images,
        include,
        groupValue,
        map.allVariants || [],
        map.visualOption || map.resolver.visualOption || 'option1',
        feat
      ) || ids
    );
  }

  function imageIdsForVariant(map, variant, root) {
    if (!map) return null;

    var groupValue = resolveVisualGroupValue(root, map);
    if (!groupValue && variant && window.AndradePdpGallery) {
      groupValue = window.AndradePdpGallery.groupForVariant(variant, map.visualOption || 'option1');
    }
    if (!groupValue && variant) {
      var visualKey = map.visualOption || 'option1';
      if (variant[visualKey] != null) groupValue = norm(variant[visualKey]);
    }

    if (
      groupValue &&
      map.byVisual &&
      map.byVisual[groupValue] &&
      map.byVisual[groupValue].imageIds &&
      map.byVisual[groupValue].imageIds.length
    ) {
      return reorderGalleryIds(
        map,
        map.byVisual[groupValue].imageIds.map(String),
        groupValue,
        variant
      );
    }

    var computed = computeGalleryIds(map, groupValue, variant);
    if (computed && computed.length) {
      return reorderGalleryIds(map, computed, groupValue, variant);
    }

    if (!variant || !variant.id) return null;
    var variantId = String(variant.id);
    var entry = map.variants && map.variants[variantId];
    if (!entry) return null;

    var imageIds = entry.imageIds || entry.mediaIds || [];
    if (!imageIds || !imageIds.length) return null;
    return reorderGalleryIds(map, imageIds.map(String), groupValue, variant);
  }

  function fillGalleryGridSlots(imageIds, maxSlots) {
    if (window.AndradePdpGallery && typeof window.AndradePdpGallery.fillGalleryGridSlots === 'function') {
      return window.AndradePdpGallery.fillGalleryGridSlots(imageIds, maxSlots);
    }
    var limit = Math.max(1, Number(maxSlots) || 4);
    if (!imageIds || !imageIds.length) return [];
    if (imageIds.length >= limit) return imageIds.slice(0, limit);
    var filled = [];
    var i;
    for (i = 0; i < limit; i += 1) {
      filled.push(imageIds[i % imageIds.length]);
    }
    return filled;
  }

  function gridImageIds(map, variant, root) {
    var all = imageIdsForVariant(map, variant, root);
    if (!all || !all.length) return null;
    var maxSlots = map.maxSlots || 4;
    return fillGalleryGridSlots(all, maxSlots);
  }

  function stickyImageFromGallery(root) {
    var cellImg =
      root.querySelector('[data-md-gallery-cell] .md-pdp__gallery-cell-img') ||
      root.querySelector('.md-pdp__gallery-cell-img');
    return cellImg && cellImg.src ? cellImg.src : null;
  }

  function swatchSrcFromPicker() {
    var picker = getPicker();
    if (!picker) return null;
    var visualFieldset = picker.querySelector('[data-md-visual-option="true"]');
    var scope = visualFieldset || picker;
    var checked = scope.querySelector('input[type="radio"]:checked') || picker.querySelector('input[type="radio"]:checked');
    if (!checked) return null;
    var label = checked.closest('label');
    var swatchImg = label ? label.querySelector('.andrade-color-swatch__img') : null;
    return swatchImg && swatchImg.src ? swatchImg.src : null;
  }

  function resolveStickyImageSrc(root, map, variant) {
    var src = null;

    if (variant && variant.id && map) {
      src = firstImageSrc(map, imageIdsForVariant(map, variant, root));
      if (src) return src;
    }

    src = swatchSrcFromPicker();
    if (src) return src;

    if (variant && variant.featured_image && variant.featured_image.src) {
      return variant.featured_image.src;
    }

    src = stickyImageFromGallery(root);
    if (src) return src;

    return null;
  }

  function formatMoney(cents, format) {
    var amount = (Number(cents) / 100).toFixed(2);
    var tpl = format || '{{amount}}';
    if (tpl.indexOf('{{amount}}') >= 0) return tpl.replace('{{amount}}', amount);
    if (tpl.indexOf('{{ amount }}') >= 0) return tpl.replace('{{ amount }}', amount);
    return 'R$ ' + amount.replace('.', ',');
  }

  function updateStickyTitle(root) {
    var stickyTitle = document.querySelector('[data-md-sticky-title]');
    if (!stickyTitle || !root) return;

    var pageTitle = root.querySelector('.md-pdp__title');
    if (pageTitle && pageTitle.textContent && pageTitle.textContent.trim()) {
      stickyTitle.textContent = pageTitle.textContent.trim();
    }
  }

  function updateStickyPrice(root, variant) {
    var stickyPrice = document.querySelector('[data-md-sticky-price]');
    if (!stickyPrice) return;

    var pixBlock = root.querySelector('[data-md-pix-block]');
    var pixEl = root.querySelector('[data-md-pix]');
    var pixDealVisible = pixBlock && !pixBlock.hidden && pixEl && pixEl.textContent && pixEl.textContent.trim();
    if (pixDealVisible) {
      stickyPrice.textContent = pixEl.textContent;
      return;
    }

    if (!variant || variant.price == null) return;

    var pixPct = Number(root.dataset.pixDiscount || 5);
    if (pixPct > 0) {
      var pixCents = Math.round(Number(variant.price) * (100 - pixPct) / 100);
      var pixSaved = Number(variant.price) - pixCents;
      if (pixSaved > 0) {
        var tpl = root.dataset.pixTemplate || '';
        var money = formatMoney(pixCents, root.dataset.moneyFormat);
        stickyPrice.textContent = tpl.indexOf('__PRICE__') >= 0 ? tpl.replace('__PRICE__', money) : money;
        return;
      }
    }

    stickyPrice.textContent = formatMoney(variant.price, root.dataset.moneyFormat);
  }

  function setStickyImage(src, variantId) {
    var img = document.querySelector('[data-md-sticky-image]');
    if (!img || !src) return;

    var id = variantId != null ? String(variantId) : '';
    var nextSrc = String(src);

    if (id && img.dataset.mdVariantId === id && img.getAttribute('src') === nextSrc) return;

    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.setAttribute('src', nextSrc);
    if (id) img.dataset.mdVariantId = id;
    img.removeAttribute('hidden');
  }

  function applyStickyState(root, map, variant) {
    if (!variant || !variant.id) return;

    var variantId = String(variant.id);
    syncVariantInput(variantId);
    updateGalleryForVariant(root, map, variant);
    setStickyImage(resolveStickyImageSrc(root, map, variant), variantId);
    updateStickyTitle(root);
    updateStickyPrice(root, variant);

    var sticky = document.querySelector('andrade-sticky-cart');
    if (!sticky) return;

    sticky.dataset.activeVariantId = variantId;
    state.lastVariantId = variantId;

    var btn = sticky.querySelector('[data-md-sticky-buy-now]');
    var buyNowLabel = sticky.dataset.labelBuyNow || 'Comprar agora';
    if (btn) {
      btn.textContent = buyNowLabel;
      btn.disabled = false;
    }
    sticky.dataset.variantAvailable = 'true';

    var buyNow = root.querySelector('[data-md-buy-now]');
    var pdpBuyNow = root.dataset.labelBuyNow || buyNowLabel;
    if (buyNow) {
      buyNow.disabled = false;
      buyNow.textContent = pdpBuyNow;
    }
    var meta = root.querySelector('[data-md-stock]');
    if (meta && window.AndradeInventoryPolicy) {
      window.AndradeInventoryPolicy.applyStockMeta(meta, variant);
    }
    var notify = root.querySelector('[data-md-notify]');
    if (notify) notify.classList.add('hidden');
    sticky.removeAttribute('hidden');
  }

  function renderGallery(root, map, gridIds, fullIds) {
    var grid = root.querySelector('[data-md-gallery-grid]');
    if (!grid || !map || !map.images || !gridIds || !gridIds.length) return;
    var maxSlots = map.maxSlots || Number(grid.dataset.slots) || 4;
    var totalImages = (fullIds && fullIds.length) || gridIds.length;
    var moreCount = Math.max(0, totalImages - maxSlots);
    var zoomLabel = root.dataset.galleryZoomLabel || 'Ampliar foto __INDEX__';
    var moreBadgeTpl = root.dataset.galleryMoreBadge || '+__COUNT__';
    grid.dataset.totalImages = String(totalImages);
    grid.innerHTML = '';

    for (var slot = 0; slot < maxSlots; slot += 1) {
      var id = gridIds[slot];
      var data = id != null ? map.images[String(id)] : null;
      if (data && data.src900) {
        var btn = document.createElement('button');
        btn.type = 'button';
        var isLastWithMore = slot === maxSlots - 1 && moreCount > 0;
        btn.className =
          'md-pdp__gallery-cell' + (isLastWithMore ? ' md-pdp__gallery-cell--has-more' : '');
        btn.setAttribute('role', 'listitem');
        btn.setAttribute('data-md-gallery-cell', '');
        btn.setAttribute('data-image-id', String(id));
        btn.setAttribute('aria-label', zoomLabel.replace('__INDEX__', String(slot + 1)));
        var img = document.createElement('img');
        img.className = 'md-pdp__gallery-cell-img';
        img.alt = data.alt || '';
        img.loading = slot === 0 ? 'eager' : 'lazy';
        img.removeAttribute('src');
        img.src = data.src900;
        img.sizes = '(min-width: 990px) 26vw, 46vw';
        btn.appendChild(img);
        if (isLastWithMore) {
          var badge = document.createElement('span');
          badge.className = 'md-pdp__gallery-cell-more';
          badge.setAttribute('aria-hidden', 'true');
          badge.textContent = moreBadgeTpl.replace('__COUNT__', String(moreCount));
          btn.appendChild(badge);
        }
        grid.appendChild(btn);
      } else {
        var empty = document.createElement('div');
        empty.className = 'md-pdp__gallery-cell md-pdp__gallery-cell--empty';
        empty.setAttribute('role', 'listitem');
        empty.setAttribute('aria-hidden', 'true');
        grid.appendChild(empty);
      }
    }
  }

  function updateGalleryForVariant(root, map, variant) {
    var fullIds = imageIdsForVariant(map, variant, root);
    if (!fullIds || !fullIds.length) return;
    var groupValue = resolveVisualGroupValue(root, map) || '';
    if (!groupValue && variant && window.AndradePdpGallery) {
      groupValue = window.AndradePdpGallery.groupForVariant(variant, map.visualOption || 'option1');
    }
    var galleryKey = groupValue + '|' + fullIds.join(',');
    if (state.lastGalleryKey === galleryKey) return;
    state.lastGalleryKey = galleryKey;
    var gridIds = fillGalleryGridSlots(fullIds, map.maxSlots || 4);
    renderGallery(root, map, gridIds, fullIds);

    var stickySrc = resolveStickyImageSrc(root, map, variant);
    if (stickySrc) {
      setStickyImage(stickySrc, variant && variant.id ? variant.id : null);
    }
  }

  function onVariantResolved(root, map, variant) {
    if (!variant || !variant.id) return;
    applyStickyState(root, map, variant);
  }

  function scheduleVariantSync(root, map) {
    state.changeGeneration += 1;
    var generation = state.changeGeneration;

    function attempt(retry) {
      if (generation !== state.changeGeneration) return;
      if (applyResolvedVariant(root, map)) return;
      if (retry < 24) {
        window.setTimeout(function () {
          attempt(retry + 1);
        }, retry < 6 ? 50 : 100);
      }
    }

    applyResolvedVariant(root, map);

    [0, 50, 120, 250, 400].forEach(function (delay) {
      window.setTimeout(function () {
        if (generation !== state.changeGeneration) return;
        applyResolvedVariant(root, map);
      }, delay);
    });

    window.setTimeout(function () {
      attempt(0);
    }, 80);
  }

  function stickyBuyNow() {
    var root = getPdpRoot();
    var variant = root ? resolveActiveVariant(root) : null;
    var variantId = variant && variant.id ? Number(variant.id) : null;

    if (!variantId) {
      var input =
        document.querySelector('[data-md-product-form] input[name="id"]') ||
        document.querySelector('product-form-component input[name="id"]');
      variantId = input && input.value ? Number(input.value) : null;
    }

    if (!variantId) return;

    syncVariantInput(variantId);

    var btn = document.querySelector('[data-md-sticky-buy-now]');
    if (btn && (btn.disabled || btn.dataset.mdSubmitting === 'true' || btn.classList.contains('md-pdp__btn--busy'))) {
      return;
    }

    var form = document.querySelector('[data-md-product-form]');
    if (
      window.AndradePdpLineItem &&
      typeof window.AndradePdpLineItem.validateFormAssociatedFields === 'function' &&
      !window.AndradePdpLineItem.validateFormAssociatedFields(form, root)
    ) {
      return;
    }

    if (btn) {
      btn.dataset.mdSubmitting = 'true';
      btn.classList.add('md-pdp__btn--busy');
      btn.setAttribute('aria-busy', 'true');
    }

    var built =
      window.AndradePdpLineItem && typeof window.AndradePdpLineItem.buildBuyNowItems === 'function'
        ? window.AndradePdpLineItem.buildBuyNowItems(form, root, variantId)
        : { ok: true, items: [{ id: variantId, quantity: 1 }] };

    if (!built.ok || !built.items) {
      if (btn) {
        btn.classList.remove('md-pdp__btn--busy');
        btn.removeAttribute('aria-busy');
        delete btn.dataset.mdSubmitting;
      }
      return;
    }

    var drawer = document.querySelector('cart-drawer-component');
    if (drawer && typeof drawer.open === 'function') drawer.open();

    var payload = { items: built.items };
    var sectionIds =
      window.AndradePdpLineItem && typeof window.AndradePdpLineItem.collectCartSectionIds === 'function'
        ? window.AndradePdpLineItem.collectCartSectionIds()
        : [];
    if (sectionIds.length) {
      payload.sections = sectionIds.join(',');
      payload.sections_url = window.location.pathname;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload),
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart add failed');
        return res.json().catch(function () {
          return null;
        });
      })
      .then(function (cart) {
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: 'andrade-sticky-buy',
              data: {
                source: 'product-form-component',
                itemCount: cart && cart.item_count != null ? cart.item_count : 1,
                sections: cart && cart.sections,
              },
            },
          })
        );
        if (btn) {
          btn.classList.remove('md-pdp__btn--busy');
          btn.removeAttribute('aria-busy');
          delete btn.dataset.mdSubmitting;
        }
      })
      .catch(function () {
        if (drawer && typeof drawer.close === 'function') drawer.close();
        if (btn) {
          btn.classList.remove('md-pdp__btn--busy');
          btn.removeAttribute('aria-busy');
          delete btn.dataset.mdSubmitting;
        }
      });
  }

  function setupStickyBar() {
    if (window.__mdPdpBuyBarsSetup) return;

    var pdpRoot = document.querySelector('[data-md-pdp]');
    var buyColumn = pdpRoot ? pdpRoot.querySelector('.md-pdp__buy') : null;
    var buyFooter = pdpRoot ? pdpRoot.querySelector('[data-md-pdp-buy-footer]') : null;
    var footerSlot = pdpRoot ? pdpRoot.querySelector('[data-md-pdp-buy-footer-slot]') : null;
    var paymentsSentinel = document.querySelector('[data-md-pdp-payments-sentinel]');
    var paymentsBlock = document.querySelector('.andrade-payments--pdp');
    var siteFooter = document.querySelector('footer') || document.querySelector('[class*="footer-group"]');
    if (!pdpRoot || !buyColumn || !buyFooter || !footerSlot) return;

    window.__mdPdpBuyBarsSetup = true;

    var hiddenBySiteFooter = false;
    var dockMq = window.matchMedia('(max-width: 989px)');
    var buyBarPhase = '';
    var tickPending = false;
    var PHASE_CLASSES = ['md-pdp-buy-phase-docked', 'md-pdp-buy-phase-inline', 'md-pdp-buy-phase-hidden'];
    var buyNowBtn = buyFooter.querySelector('[data-md-buy-now]');

    function footerHeightPx() {
      return Math.ceil(buyFooter.offsetHeight || buyFooter.getBoundingClientRect().height || 0);
    }

    function reserveSlot(on) {
      var height = footerHeightPx();
      if (on && height > 0) {
        buyColumn.style.setProperty('--md-pdp-dock-height', height + 'px');
        footerSlot.classList.add('is-reserved');
      } else {
        footerSlot.classList.remove('is-reserved');
        buyColumn.style.removeProperty('--md-pdp-dock-height');
      }
    }

    function setDock(on) {
      var isDocked = buyFooter.classList.contains('is-docked');
      if (on === isDocked) return;
      buyFooter.classList.toggle('is-docked', on);
      reserveSlot(on);
    }

    function setPhaseClass(nextPhase) {
      var i;
      for (i = 0; i < PHASE_CLASSES.length; i += 1) {
        pdpRoot.classList.remove(PHASE_CLASSES[i]);
      }
      if (nextPhase === 'docked') pdpRoot.classList.add('md-pdp-buy-phase-docked');
      if (nextPhase === 'inline') pdpRoot.classList.add('md-pdp-buy-phase-inline');
      if (nextPhase === 'hidden') pdpRoot.classList.add('md-pdp-buy-phase-hidden');
    }

    function applyBuyBarPhase(nextPhase) {
      if (nextPhase === buyBarPhase) return;
      buyBarPhase = nextPhase;
      setPhaseClass(nextPhase);

      if (nextPhase === 'hidden' || nextPhase === 'inline') {
        setDock(false);
        return;
      }

      setDock(true);
    }

    function computePhase() {
      if (hiddenBySiteFooter) return 'hidden';

      if (!dockMq.matches) {
        return 'inline';
      }

      var vh = window.innerHeight;
      var docked = buyFooter.classList.contains('is-docked');
      var markerTop;
      var markerBottom;

      /*
        Quando docked, o COMPRAR AGORA fica fixed e sempre “visível”.
        O slot reservado marca o bloco original no fluxo.
        Fora do dock, o slot tem altura 0 no topo do footer — usar o botão da página.
      */
      if (docked) {
        var slotRect = footerSlot.getBoundingClientRect();
        markerTop = slotRect.top;
        markerBottom = slotRect.bottom;
      } else if (buyNowBtn) {
        var btnRect = buyNowBtn.getBoundingClientRect();
        markerTop = btnRect.top;
        markerBottom = btnRect.bottom;
      } else {
        return 'inline';
      }

      var edge = 16;

      /* Botão da página ainda no viewport — não duplicar com a barra fixa */
      if (markerBottom > edge && markerTop < vh - edge) {
        return 'inline';
      }

      /* Ainda não chegou no botão (galeria / topo) */
      if (markerTop >= vh - edge) {
        return 'inline';
      }

      /* Rolou para baixo e o botão da página saiu da tela */
      return 'docked';
    }

    function refreshBuyBars() {
      applyBuyBarPhase(computePhase());
    }

    function scheduleRefresh() {
      if (tickPending) return;
      tickPending = true;
      window.requestAnimationFrame(function () {
        tickPending = false;
        refreshBuyBars();
      });
    }

    if (typeof IntersectionObserver !== 'undefined') {
      var ioOpts = { root: null, threshold: [0, 0.01, 0.1, 0.25] };
      new IntersectionObserver(scheduleRefresh, ioOpts).observe(footerSlot);
      new IntersectionObserver(scheduleRefresh, ioOpts).observe(buyFooter);
      if (buyNowBtn) {
        new IntersectionObserver(scheduleRefresh, ioOpts).observe(buyNowBtn);
      }

      if (paymentsBlock) {
        new IntersectionObserver(scheduleRefresh, ioOpts).observe(paymentsBlock);
      } else if (paymentsSentinel) {
        new IntersectionObserver(scheduleRefresh, ioOpts).observe(paymentsSentinel);
      }

      if (siteFooter) {
        new IntersectionObserver(function (entries) {
          var entry = entries[0];
          if (!entry) return;
          hiddenBySiteFooter = entry.isIntersecting;
          scheduleRefresh();
        }).observe(siteFooter);
      }
    }

    window.addEventListener('scroll', scheduleRefresh, { passive: true });
    window.addEventListener(
      'resize',
      function () {
        if (buyFooter.classList.contains('is-docked')) {
          reserveSlot(true);
        }
        scheduleRefresh();
      },
      { passive: true }
    );

    if (typeof dockMq.addEventListener === 'function') {
      dockMq.addEventListener('change', scheduleRefresh);
    }

    refreshBuyBars();
  }

  function watchPickerJson(root, map) {
    var picker = getPicker();
    if (!picker || typeof MutationObserver === 'undefined') return;

    var script = picker.querySelector('script[type="application/json"]');
    if (!script) return;

    if (script._mdJsonObserver) {
      script._mdJsonObserver.disconnect();
      script._mdJsonObserver = null;
    }

    var observer = new MutationObserver(function () {
      applyResolvedVariant(root, map);
    });

    script._mdJsonObserver = observer;
    observer.observe(script, { characterData: true, childList: true, subtree: true });
  }

  function handleVariantEvent(root, map) {
    state.lastVariantId = null;
    state.lastGalleryKey = null;
    applyResolvedVariant(root, map);
    scheduleVariantSync(root, map);
  }

  function initRoot(root) {
    if (!root || root.dataset.mdPdpInit === 'true') return;
    var map = parseMap(root);
    if (!map) return;

    root.dataset.mdPdpInit = 'true';

    root.addEventListener('change', function (event) {
      var target = event.target;
      if (!target || target.type !== 'radio') return;
      if (!target.closest || !target.closest('variant-picker.andrade-pdp-variant-picker')) return;

      state.lastVariantId = null;
      state.lastGalleryKey = null;
      applyResolvedVariant(root, map);
      updateGalleryForVariant(root, map, resolveActiveVariant(root));
      scheduleVariantSync(root, map);
    });

    var form = root.querySelector('[data-md-product-form]');
    if (form) {
      form.addEventListener('submit', function () {
        var variant = resolveActiveVariant(root);
        if (variant && variant.id) syncVariantInput(variant.id);
      });
    }

    document.addEventListener('variant:update', function (event) {
      var detail = event.detail;
      if (!detail) return;
      var productId = detail.data && detail.data.productId;
      if (productId && String(productId) !== String(root.dataset.productId)) return;
      /* Após morph do Horizon + product-form (input id errado do JSON parcial) */
      handleVariantEvent(root, map);
    });

    document.addEventListener('variant:selected', function () {
      state.lastVariantId = null;
      scheduleVariantSync(root, map);
    });

    watchPickerJson(root, map);

    var initial = resolveActiveVariant(root);
    state.lastGalleryKey = null;
    if (initial && initial.id) {
      onVariantResolved(root, map, initial);
    } else {
      updateGalleryForVariant(root, map, initial);
    }
  }

  function boot() {
    var nodes = document.querySelectorAll('[data-md-pdp]');
    for (var i = 0; i < nodes.length; i += 1) initRoot(nodes[i]);
    setupStickyBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;
    var root = event.target.querySelector ? event.target.querySelector('[data-md-pdp]') : null;
    if (root) initRoot(root);
    setupStickyBar();
  });
})();
